export abstract class BaseGooglePlaces {
  static getPlaceAutocomplete: (
    input: string,
    types?: string[],
    locationBias?: google.maps.LatLngBoundsLiteral,
  ) => Promise<google.maps.places.AutocompletePrediction[]>;

  static getPlaceDetails: (
    placeID: string,
  ) => Promise<google.maps.places.PlaceResult>;
}
